import { render, staticRenderFns } from "./CompilationTextAndBtns.vue?vue&type=template&id=2f346248&scoped=true&"
import script from "./CompilationTextAndBtns.vue?vue&type=script&lang=js&"
export * from "./CompilationTextAndBtns.vue?vue&type=script&lang=js&"
import style0 from "./CompilationTextAndBtns.vue?vue&type=style&index=0&id=2f346248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f346248",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
